// Base URL for the images from the API
export const MOVIES_PER_GAME = 10;
export const GAME_TIME = 180;
export const IMAGE_WIDTH = 780;
export const THUMBNAIL_WIDTH = 60;
export const IMAGE_BASE_URL = `https://image.tmdb.org/t/p/w${IMAGE_WIDTH}`;